import React from "react";
import "./Chip.css";
import {
  Chip as SharedChip,
  ChipsProps,
} from "../../../../shared/components/Atoms/Chip/Chip";

export const Chip = (props: ChipsProps) => <SharedChip {...props} />;
